//The link of setting contact us page.
export const PURCHASE_LINK = "https://buy.cloud.tencent.com/avc";
export const CONTACT_LINK =
  "https://cloud.tencent.com/act/event/connect-service";

export const APASSSERVER =
  "https://demos.trtc.tencent-cloud.com/prod/base/v1/gslb";

export const USEERVERIFYBYPICTURE =
  "https://demos.trtc.tencent-cloud.com/prod/base/v1/auth_users/user_verify_by_picture";

export const LOGINSMS =
  "https://demos.trtc.tencent-cloud.com/prod/base/v1/auth_users/user_login_code";

export const APASSSERVERBASE =
  "https://demos.trtc.tencent-cloud.com/prod/base/v1";

export const DEFAULT_SDKAPPID = ""; // SDK app id
export const DEFAULT_USERID = "";
export const DEFAULT_USER_SIG = "";
export const HISTORY_MESSAGE_COUNT = 100;

export const DEFAULT_SETTING_CONFIG = {
  userId: DEFAULT_USERID,
  sdkappId: DEFAULT_SDKAPPID,
  userSig: DEFAULT_USER_SIG,
};

export const CUSTOM_MSG_SOURCE = {
  FILE: 1,
  LESSON_INFO: 2,
  NOTICE: 3,
};

export const MESSAGE_TYPE = {
  TEXT: 0,
  IMAGE: 1,
  SOUND: 2,
  CUSTOM: 3,
  FILE: 4,
  GROUP_TIPS: 5,
  FACE: 6,
  LOCATION: 7,
  GROUP_REPORT: 8,
  VIDEO: 9,
  FRIEND_CHANGE: 10,
  PROFILE_CHANGE: 11,
};
// 消息状态
export const MESSAGE_STATUS = {
  SENDING: 1,
  SUCCESS: 2,
  FAIL: 3,
  DELETED: 4,
  LOCAL_IMPORTED: 5,
  REVOKED: 6,
  CANCEL: 7,
};
// 会话类型
export const CONV_TYPE = {
  C2C: 1,
  GROUP: 2,
};

// 用户角色
export const IM_ORG_ROLE = {
  Owner: {
    sort: 1,
    text: "拥有者",
    color: "rgba(0, 200, 157, 1)",
  },
  SuperAdmin: {
    sort: 2,
    text: "超管",
    color: "rgba(255, 134, 41, 1)",
  },
  CourseAdmin: {
    sort: 3,
    text: "课管",
    color: "rgba(255, 134, 41, 1)",
  },
  Teacher: {
    sort: 4,
    text: "老师",
    color: "rgba(47, 164, 243, 1)",
  },
  Assistant: {
    sort: 5,
    text: "助教",
    color: "rgba(232, 189, 77, 1)",
  },
};
